import { AxiosPromise } from "axios";
import { makeObservable, observable, runInAction } from "mobx";
import pl from "messages/pl";

export interface RequestStatus {
  isPending: boolean;
  isDone: boolean;
  error: string;

  handleAnyRequest<TResponse>(
    fetchMethod: () => AxiosPromise<TResponse>,
    showOriginalErrorMessage?: boolean
  ): Promise<TResponse | null>;
  reset: () => void;
}

export class DefaultRequestStatus implements RequestStatus {
  _isPending: boolean = false;
  _isDone: boolean = false;
  _error: string = "";

  constructor() {
    makeObservable(this, {
      _isPending: observable,
      _isDone: observable,
      _error: observable,
    });
  }

  public get isPending() {
    return this._isPending;
  }

  public get isDone() {
    return this._isDone;
  }

  public get error() {
    return this._error;
  }

  public reset() {
    this._isPending = false;
    this._isDone = false;
    this._error = "";
  }

  public async handleAnyRequest<TResponse>(
    fetchMethod: () => AxiosPromise<TResponse>,
    showOriginalErrorMessage = false
  ): Promise<TResponse | null> {
    return this.handle<TResponse>(async () => {
      const response = await fetchMethod();

      return response.data;
    }, showOriginalErrorMessage);
  }

  private async handle<T>(
    method: () => Promise<T>,
    showOriginalErrorMessage = false
  ) {
    try {
      runInAction(() => {
        this._isPending = true;
        this._isDone = false;
        this._error = "";
      });

      return await method();
    } catch (err) {
      runInAction(() => {
        if (showOriginalErrorMessage && err?.response?.data[0]?.description) {
          this._error = err.response.data[0].description;
        } else {
          this._error = pl.errors.api;
        }

        // LogService.logException({ error: new Error(err) });
      });

      return null;
    } finally {
      runInAction(() => {
        this._isPending = false;
        this._isDone = true;
      });
    }
  }
}
